module.exports = __webpack_public_path__ + "img/check-list.000531b6.svg";